<script>
  export let block;

  $: headline = () => {
    const headline = block.primary.headline[0];
    const type = headline.type.replace("heading", "");
    return `<h${type} class="text-5xl lg:text-8xl font-extrabold max-w-6xl text-center">${headline.text.replace(
      /\n/g,
      "<br>",
    )}</h${type}>`;
  };
</script>

<div
  class="{block.primary.background
    ? 'dark'
    : 'light'} py-32 px-8 flex flex-col items-center justify-center"
  class:pattern={block.primary.pattern}
>
  <img src="/quote.png" alt="quote icon" class="w-16 block" />
  {@html headline()}
</div>
